module.exports = __webpack_public_path__ + "img/Icon-sidebar-tree.86a10b95.svg";